@if(profileDetails){
    <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
        <div class="card-header fs-5 fw-medium">Agency ID</div>
        <div class="card-body">
            <div class="row g-3">
                <div class="col-md-12">
                    <label class="form-label">Agency ID(s)</label>
                    <dx-tag-box
                        [(value)]="profileDetails.agencyIds"
                        [dataSource]="agencyDataSource"
                        displayExpr="name"
                        valueExpr="id"
                        [searchEnabled]="true"
                        [showClearButton]="true"
                        stylingMode="filled"
                        (onValueChanged)="onFieldChange($event)"
                        [readOnly]="isReadOnly"
                    >
                    </dx-tag-box>
                </div>
            </div>
        </div>
    </div>
}
